import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { list_categories } from '@/graphql/queries'

export default {
  data() {
    return {
      categoriesList: [],

    }
  },
  methods: {
    async fetchCategories() {


      try {
        const response = await client.graphql({
          query: list_categories,
          variables: {
            input: {
                source:"BMS"
            }
          }
        })

        let responseData = JSON.parse(response.data.list_categories)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.categoriesList = responseData.data
        } else {
          this.categoriesList = []
        }
        // console.log(this.categoriesList)

      } catch (error) {
        console.error("Error fetching categories:", error);
        if (error == 'NoValidAuthTokens: No federated jwt') {
          this.$router.push("/login");
          this.$store.dispatch("logout");
          this.$store.dispatch("clearAuth");
          this.$store.dispatch("clearUser");
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearRefreshToken");
          this.$store.dispatch("clearExpiresAt");
          this.$store.dispatch("clearExpiresIn");
        }
        this.categoriesList = [];
        throw error;
      }
    },
  },
};

